module.exports = "/fonts/vendor/boxicons/boxicons.ttf?8829e87f7fef25fef075707895401297";